<p-select
  [options]="selectablePlantations"
  [(ngModel)]="selectedPlantation"
  (onChange)="onSelect(selectedPlantation)">
  <ng-template #selectedItem let-selectedOption>
    <div class="selected-plantation">
      <div
        class="plantation-img"
        [dkSafeImage]="selectedOption?.plantationImage"
        fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
        backgroundStyle="lightgray 50% / cover no-repeat"
        [showSpinner]="true"></div>
      <span class="plantation-name">
        {{ selectedOption.landName }}, {{ selectedOption.plantationName }}
        @if (selectedOption.assetId) {
          , {{ selectedOption.assetId | truncate: 4 }}
        } @else if (selectedOption.totalArea != null) {
          , {{ selectedOption.totalArea | number: '1.0-0' }}ha
        }
      </span>
    </div>
  </ng-template>
  <ng-template #item let-option>
    <div class="selected-plantation">
      <div
        class="plantation-img"
        [dkSafeImage]="option?.plantationImage"
        fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
        backgroundStyle="lightgray 50% / cover no-repeat"
        [showSpinner]="true"></div>
      <span class="plantation-name">
        {{ option.landName }}, {{ option.plantationName }}
        @if (option.assetId) {
          , {{ option.assetId | truncate: 4 }}
        } @else if (option.totalArea != null) {
          , {{ option.totalArea | number: '1.0-0' }}ha
        }
      </span>
    </div>
  </ng-template>
</p-select>
